<template>
    <div class="registry-wrapper">
        <div class="add-anexo" v-if="permissao.create && !this.integracao">
            <div class="columns">
                <div class="file-picker-input">
                    <file-picker
                        v-if="permissao.create"
                        ref="filePicker"
                        class="upload-picker"
                        v-model="file"
                        :accepted="acceptedTypes"
                        :allowedtypes="allowedTypes"
                        @alert="showMessage"
                        :disabled="disabled"
                        returnRawFile
                    />
                </div>
                <div class="listing-header mb-4">
                    <div class="title-breadcrumb"></div>
                    <div class="header-buttons">
                        <button
                            class="save-btn"
                            type="button"
                            :disabled="!file"
                            @click="addAnexoCall"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="disabled" />
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- TABELA -->
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <empty-table-message v-if="isEmpty" />

        <b-table v-else class="data-table" :data="anexos" @sort="sortTable" backend-sorting>
            <b-table-column
                v-for="(f, i) in fields"
                :key="i"
                :field="f.field"
                :label="f.key != 'excluir' ? $t(f.key) : ''"
                :width="f.width"
                :class="{
                    'excluir-field': f.key == 'excluir',
                }"
                :sortable="f.sortable"
                v-slot="props"
            >
                <div v-if="f.key == 'excluir'">
                    <span v-if="permissao.delete">
                        <b-button
                            class="action-button"
                            type="is-danger"
                            icon-right="delete"
                            @click="confirmExclusion(props.row)"
                            v-tippy
                            :title="$t('excluir')"
                        />
                    </span>
                </div>
                <div v-else-if="f.field == 'datahora'">
                    {{ props.row[f.field] | moment('L') }}
                </div>
                <div v-else-if="f.field == 'nome'">{{ props.row[f.field] }}</div>
                <div
                    v-else-if="
                        f.field == 'caminho' &&
                        props.row[f.field] &&
                        ['jpg', 'jpeg', 'png'].includes(
                            props.row['nome']
                                .split('.')
                                [props.row['nome'].split('.').length - 1].toLowerCase()
                        )
                    "
                >
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="props.row[f.field]"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
                <div v-else>
                    <a :href="props.row[f.field]" target="_blank">
                        <img
                            :src="require('@/assets/img/file.png')"
                            class="img-anexo"
                            :title="props.row['nome']"
                            :alt="props.row['nome']"
                        />
                    </a>
                </div>
            </b-table-column>
        </b-table>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import FilePicker from '@/components/shared/form/FilePicker';
import AnexoService from '@/services/agro/ocorrencia/AnexoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        FilePicker,
        ContainerLoader,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ANEXOOCORRENCIAPDA'
            ),
            service: new AnexoService(this.$http, this.$router),
            anexos: [],
            msgs: [],
            situacaoSelected: { label: 'ativo', id: 1 },
            situacaoSelect: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            fields: [
                { key: 'arquivo', field: 'caminho', sortable: false },
                { key: 'nome', field: 'nome', sortable: true },
                { key: 'datahora', field: 'datahora', sortable: true },
                { key: 'excluir', label: 'excluir', width: 20, sortable: false },
            ],
            file: '',
            promptedForRemoval: null,
            allowedTypes: [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/csv',
                'text/plain',
                'text/html',
                'application/pdf',
                'application/msword',
                'image/jpeg',
                'image/png',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ],
            acceptedTypes: '.xls,.xlsx,.csv,.pdf,.doc,.docx,.txt,.html,.jpeg,.jpg,.png',
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'arquivo',
            order: 'asc',
            fromDelete: false,
            disabled: false,
            isEmpty: false,
            isLoading: false,
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-ocorrencia');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-ocorrencia');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ocorrencia' },
            });
        } else {
            this.carregarDados();
        }
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.$route.params.id
                )
                .then(this.mapItems)
                .then((value) => {
                    this.anexos = value;
                    this.isEmpty = this.anexos.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.error('Erro ao carregar aba licenca', e);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-licenca-load');
                })
                .finally(() => {
                    this.isLoading = false;
                    if (this.fromDelete) {
                        this.fromDelete = false;
                    }
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.id,
                    caminho: m.caminho,
                    nome: m.nome,
                    datahora: m.datahora,
                    excluir: 'excluir',
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        addAnexoCall() {
            this.addAnexo({
                nome: this.$refs.filePicker.file.name,
            });
            this.file = '';
            this.$refs.filePicker.clearFile();
        },
        addAnexo(anexo) {
            anexo.idagro_ocorrencia = this.$route.params.id;
            this.loadingAnexo = true;
            anexo = this.mapToupload(anexo, 'anexob64');

            this.service.save(this.$refs.filePicker.file, anexo).then((r) => {
                if (r.status != 200) {
                    console.error(`Erro ${r.status} ao salvar anexo.`);
                    console.error(`Mensagem: ${r.message}`);
                    this.$root.showMessage('error', 'msg-erro-ven-cliente-anexo-upload');
                } else {
                    this.loadingAnexo = false;
                    this.$root.showMessage('success', 'msg-anexo-salvo-sucesso');
                    this.carregarDados();
                }
            });
        },
        confirmExclusion(anexo) {
            this.promptedForRemoval = anexo.id;

            this.$root.confirm({
                message: this.$t('msg-confirmacao'),
                onConfirm: (_) => this.deleteAnexo(),
            });
        },
        deleteAnexo() {
            this.service
                .delete(this.promptedForRemoval)
                .then((r) => {
                    this.fromDelete = true;
                    this.carregarDados();
                })
                .finally((_) => {
                    this.promptedForRemoval = null;
                });
        },
        showMessage(data) {
            this.$root.showMessage('alert', data);
        },
    },
};
</script>

<style lang="scss" scoped>
.file-picker-input {
    flex-grow: 1;
}

.upload-picker {
    height: 100px;
    margin: 12px;
    margin-bottom: 24px;
}
.img-anexo {
    height: 48px;
}
.data-table .ml-1 {
    margin-left: 0 !important;
}

.svg-loader {
    margin-left: 0 !important;
}

.save-btn {
    margin: 12px;
    margin-top: 24px;
}

@media only screen and (max-width: 760px) {
    .add-anexo {
        .column.is-flex {
            flex-wrap: wrap;
        }
        .save-btn {
            margin-top: 0;
        }
        .upload-picker {
            margin-bottom: 0;
        }
    }
    .svg-loader {
        margin-right: 0.5rem;
    }
}
</style>
